import { render } from "./ChatToggleButton.vue?vue&type=template&id=7dc7cb3b&scoped=true"
import script from "./ChatToggleButton.vue?vue&type=script&lang=js"
export * from "./ChatToggleButton.vue?vue&type=script&lang=js"

import "./ChatToggleButton.vue?vue&type=style&index=0&id=7dc7cb3b&scoped=true&lang=css"

import exportComponent from "/Users/delano/projects/wp-dev/wp-content/plugins/wp-sam-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc7cb3b"]])

export default __exports__